export const editIcon = () => {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={30}
        height={30}
        viewBox="0 0 24 24"
        fill="var(--dark-brown-color)"
      >
        <path
          fillRule="evenodd"
          d="M21 20a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2h18ZM6.293 13.293l11-11a1 1 0 0 1 1.32-.083l.094.083 3 3a1 1 0 0 1 .083 1.32l-.083.094-11 11a1 1 0 0 1-.576.284L10 18H7a1 1 0 0 1-.993-.883L6 17v-3a1 1 0 0 1 .206-.608l.087-.1 11-11-11 11ZM18 4.414l-10 10V16h1.586l10-10L18 4.414Z"
        />
      </svg>
    );
};